import { ActionReducerMapBuilder, CaseReducer } from '@reduxjs/toolkit';
import { Action } from 'redux';

interface TypedActionCreator<Type extends string> {
  (...args: any[]): Action<Type>;
  type: Type;
}

/**
 * Calls `builder.addCase` with one callback for multiple actions.
 * @param actions Array of actions to match
 */
export function addManyCases<State, ActionCreator extends TypedActionCreator<string>>(
  builder: ActionReducerMapBuilder<State>,
  actions: ActionCreator[],
  reducer: CaseReducer<State, ReturnType<ActionCreator>>,
) {
  actions.forEach(a => builder.addCase(a, reducer));
}
